import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { noFilterCountersQueryKey } from '@autobid/ui/composables/car/data/useNoFilterCounters'
import { NO_FILTER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useNoFilterCountersSocket'
import { useQueryClient } from '@tanstack/vue-query'

export function useNoFilterCarFinished() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const carFinished = () => {
    startListen({
      eventName: 'premium.CAR_FINISHED',
      callbackName: NO_FILTER_SOCKET_CALLBACK,
      callback: (event) => {
        /*
          courier sends double finish events, one of them is invalid and it will be fixed soon,
          the invalid event has input set to "premium"
        */
        if (event.input === 'premium')
          return

        const { nextId, auctionId } = event.context

        if (nextId)
          return

        // https://gitlab-p2.autobid.de/autobid/autobid-front/autobid-apps/-/issues/271
        const queryKey = noFilterCountersQueryKey.byAuctionId(auctionId)
        queryClient.invalidateQueries(queryKey)
      },
    })
  }

  return { carFinished }
}
